import { map } from 'rxjs/operators';
import { ReportRecord } from '../../../../../models/report.model';
import { DisplayFnArgumentsInfo, LovValues, TemplateFieldsDisplayFn } from '../../../../../models/template.model';
import { Dash, displayFnWrapper } from '../../../utils/dynamic-data-retrievers';
import {
  currencyLov,
  getClearHeight,
  PropertyType,
  propertyTypeDisplayFnFactory,
  valueWithUomPrefix,
} from '../us.common';
import {
  US_PROPERTY_COMMON_BODY_FIELDS,
  US_PROPERTY_COMMON_FOOTER_FIELDS,
  US_PROPERTY_COMMON_HEADER_FIELDS,
  filterUsagesByPropertyType,
  mapFormatAndFilterValues,
} from './us-property.common';
import { concatValuesBy } from '@miq/utils';

const industrialDisplayFnWrapper = propertyTypeDisplayFnFactory(PropertyType.Industrial);

export const displayFnMap: TemplateFieldsDisplayFn = {
  ...US_PROPERTY_COMMON_HEADER_FIELDS,

  50: {
    displayFn: (record: ReportRecord, _, market, submarket, district, neighborhood) => {
      const recordWithIndustrialUsages = filterUsagesByPropertyType(record, PropertyType.Industrial);
      const locationValues = mapFormatAndFilterValues(
        recordWithIndustrialUsages,
        [market, submarket, district, neighborhood],
        Dash
      );
      return concatValuesBy(' - ', ...locationValues);
    },
  }, // 50 - Location

  133: { displayFn: displayFnWrapper }, // 133 - Site Size
  ...US_PROPERTY_COMMON_BODY_FIELDS(PropertyType.Industrial),
  142: {
    displayFn: (record: ReportRecord, options, arg) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const TIAVal = valueWithUomPrefix(record, PropertyType.Industrial, arg, currencyLOV);
          return TIAVal;
        })
      );
    },
  }, // 142 - Tis
  145: {
    displayFn: (record: ReportRecord, options, opex) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const opexVal = valueWithUomPrefix(record, PropertyType.Industrial, opex, currencyLOV);
          return opexVal;
        })
      );
    },
  },
  146: {
    displayFn: (record: ReportRecord, options, cam) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const camVal = valueWithUomPrefix(record, PropertyType.Industrial, cam, currencyLOV);
          return camVal;
        })
      );
    },
  }, // 146 - CAMs
  ...US_PROPERTY_COMMON_FOOTER_FIELDS(PropertyType.Industrial),
  152: { displayFn: industrialDisplayFnWrapper }, // 152 - Office Space
  153: { displayFn: displayFnWrapper }, // 153 - Construction
  154: {
    // 154 - Clear Height
    displayFn: (record: ReportRecord, options, max: DisplayFnArgumentsInfo, min: DisplayFnArgumentsInfo) => {
      const values = getClearHeight(record, options, min, max);
      return values;
    },
  },
  155: { displayFn: industrialDisplayFnWrapper }, // 155 - GL Doors
  156: { displayFn: industrialDisplayFnWrapper }, // 156 - DH Doors
  157: { displayFn: industrialDisplayFnWrapper }, // 157 - Rail
  158: { displayFn: industrialDisplayFnWrapper }, // 158 - Yard
  159: { displayFn: displayFnWrapper }, // 159 - Sprinkler
  160: { displayFn: displayFnWrapper }, // 160 - Parking Spaces
  161: { displayFn: industrialDisplayFnWrapper }, // 161 - Volts
  162: { displayFn: industrialDisplayFnWrapper }, // 162 - Amps
};
